import { render, staticRenderFns } from "./CustomersAddressSelector.vue?vue&type=template&id=16cdbad7&"
import script from "./CustomersAddressSelector.vue?vue&type=script&lang=js&"
export * from "./CustomersAddressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports